export default "__VITE_ASSET__DTbktGes__"